module.exports = __webpack_public_path__ + "img/monpay.4323dec7.png";